import React from 'react'
import { useSelector } from 'react-redux'

export const AuthContext = React.createContext()

export const AuthProvider = ({ children }) => {
  const currentUser = useSelector((state) => state.users.currentUser)
  const isLoading = useSelector((state) => state.users.isFetching)

  return <AuthContext.Provider value={{ currentUser, isLoading }}>{children}</AuthContext.Provider>
}
